import React from 'react'
import styled from 'styled-components'
import { JazzIcon, Network } from '../icons'
import { Borders, ChainId, CHAIN_ID_NAMES, Colors, FontWeights } from '../../constants'
import { TokenRewards } from '../tokenRewards'
import { useEthers } from '../../hooks'
import { shortenAddress } from '../../utils'

interface Props {
  className?: string
  address: string
  onClick: () => void
}

export function Account({ className, address, onClick }: Props) {
  const { chainId } = useEthers()

  function getNetworkDisplay() {
    if (chainId && chainId !== ChainId.Mainnet) {
      return (
        <NetworkArea>
          <NetworkStyled />
          {CHAIN_ID_NAMES[chainId]}
        </NetworkArea>
      )
    }
  }

  return (
    <Container className={className}>
      {getNetworkDisplay()}
      <TokenRewards />
      <AccountArea onClick={onClick}>
        <JazzIcon address={address} size={24} />
        <Address>{shortenAddress(address)}</Address>
      </AccountArea>
    </Container>
  )
}

const Container = styled.div`
  padding: 8px 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  color: ${Colors.White};
  font-size: 13px;
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  outline: none;
  background-color: #00000020;
  border: 0;
  border-radius: ${Borders.Radius};

  > * {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }

  @media (max-width: 1024px) {
    background-color: #435069;
  }
`

const AccountArea = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  @media (max-width: 1024px) {
    margin-left: auto;
    align-item: flex-end;
  }
`

const Address = styled.span`
  margin-left: 8px;
  text-transform: none;
`

const NetworkArea = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${Colors.Red};
`

const NetworkStyled = styled(Network)`
  margin-right: 8px;
  width: 20px;
  height: 20px;
`
